// extracted by mini-css-extract-plugin
module.exports = {"WhiteText":"styles_WhiteText__JMt8R","GrayText":"styles_GrayText__3pPag","BoldText":"styles_BoldText__2bdkv","SubmitButton":"styles_SubmitButton__33iR7"};